import Bluebird from 'bluebird';
import * as $ from 'jquery';
import { eClass, eID } from './dom';

export function getSelector($element: JQuery): string {
    let selector = $element
        .parents()
        .map(function () { return this.tagName; })
        .get()
        .reverse()
        .map(x => x.toString())
        .concat([$element[0].nodeName])
        .join('>');

    const id = $element.attr('id');
    if (id) selector += '#' + id;

    const classNames = $element.attr('class');
    if (classNames) {
        selector += '.' + classNames.trim().replace(/\s/gi, '.');
    }

    return selector;
}

export function $id(id: string): JQuery {
    return $(eID(id));
}

export function $ids(ids: string[]): JQuery {
    return $(ids.map(eID));
}

export function $class(className: string): JQuery {
    return $(eClass(className));
}

export function $classes(classNames: string[]): JQuery {
    return $(classNames.reduce((list: HTMLElement[], className) => {
        list.push(...eClass(className));
        return list;
    }, []));
}

export function slideToggle($el: JQuery, show: boolean): Bluebird<void> {
    return new Bluebird(resolve => {
        if (show) $el.slideDown(400, () => resolve());
        else $el.slideUp(400, () => resolve());
    });
}

export function fadeToggle($el: JQuery, show: boolean): Bluebird<void> {
    return new Bluebird(resolve => {
        if (show) $el.fadeIn(400, () => resolve());
        else $el.fadeOut(400, () => resolve());
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/services/jquery-utils.ts